export default __webpack_public_path__ + "static/media/cv-ev posters.f9dab0f9.webp";